<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0" v-scroll="onScroll">

      <v-toolbar class="pa-0 ma-0 extension-padding" fixed flat
                 extension-height="40px">
        <v-btn icon class="mr-0" @click="goBack">
          <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <!--        <div class="channel-small-icon mr-2">채널</div>-->
        <h3 class="display-2 text-truncate">{{ productTitle }}</h3>
        <!--        <v-spacer></v-spacer>-->
        <!--        <v-btn :ripple="false"-->
        <!--               icon-->
        <!--               depressed-->
        <!--               :dark="!product.channels.subscribes"-->
        <!--               :outline="product.channels.subscribes"-->
        <!--               :color="product.channels.subscribes ? null : 'primary'"-->
        <!--               class="top-button mr-0"-->
        <!--               @click="subscribe(product.channels.idx)">-->
        <!--          <v-icon size="10px"-->
        <!--                  :color="product.channels.subscribes ? 'primary' : null"-->
        <!--                  :dark="!product.channels.subscribes">-->
        <!--            {{ product.channels.subscribes ? '$vuetify.icons.confirm' : '$vuetify.icons.add' }}-->
        <!--          </v-icon>-->
        <!--        </v-btn>-->
        <template v-slot:extension v-if="isScroll">
          <v-tabs v-model="activeTab" slider-color="#4a4a4a" mandatory color="#f8f8f8">
            <v-layout row>
              <v-flex xs4>
                <v-tab :ripple="false" href="#Introduce" class="tab" @click="$vuetify.goTo('#Introduce', tabScrollOptions)">혜택</v-tab>
              </v-flex>
              <v-flex xs4>
                <v-tab :ripple="false" href="#Program" class="tab" @click="$vuetify.goTo('#Program', tabScrollOptions)">프로그램</v-tab>
              </v-flex>
              <v-flex xs4>
                <v-tab :ripple="false" href="#School" class="tab" @click="$vuetify.goTo('#School', tabScrollOptions)">학교 보기</v-tab>
              </v-flex>
            </v-layout>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-flex xs12 v-if="loading">
        <v-progress-circular indeterminate style="margin: auto; margin-top: 100px;"></v-progress-circular>
      </v-flex>

      <v-flex xs12 style="padding-top: 56px" v-show="!loading">
        <v-card tile flat class="text-xs-left" ref="introHeader">
          <v-img :src="thumbnailSrc"
                 :aspect-ratio="16/9"
                 lazy-src="@/assets/img/thumbnail-default.png"
                 @error="isImageLoaded = false">
            <VideoPlayer ref="videoWrapper"
                         v-if="product.preview && product.preview.endsWith('.mp4')"
                         class="vjs-custom-player"
                         :options="playerOptions"
                         :playsinline="true"
                         @ready="onPlayerReady"
                         @loadeddata="onLoaded"
                         @ended="onEnded"
                         @error="onError" />
            <iframe v-else-if="product.preview && product.preview.endsWith('.youtube')"
                    id="player" type="text/html"
                    width="100%" height="100%"
                    :src="`https://www.youtube.com/embed/${product.preview.split('.')[0]}?enablejsapi=1&origin=${origin}&playsinline=1&modestbranding=1&rel=0`"
                    frameborder="0"></iframe>
          </v-img>
          <v-card-title class="mt-4 pt-0 mx-1 display-4">
            <div style="font-size: 24px; line-height: 32px; letter-spacing: -0.6px; color: #4a4a4a; width: 100%;">{{ product.title }}</div>
            <div v-if="product.subtitle" class="custom-chip mr-2">{{ product.subtitle }}</div>
            <div v-if="product.status === 'earlybird' && product.published_at" class="custom-chip">{{ new Date(product.published_at).getMonth() + 1 }}월 {{ new Date(product.published_at).getDate() }}일 런칭</div>
            <v-spacer></v-spacer>
            <v-btn icon class="my-0 pa-0" style="margin-left: auto; margin-right: -6px;" @click="share">
              <v-icon>$vuetify.icons.share</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pb-0 pt-4 px-4 mx-0 top-right-radius" style="background-color: #f8f8f8;">
            <v-layout column v-if="product.status === 'ready'">
              <div style="color: #222222; font-size: 24px; font-weight: 700;">신규 제작 예정</div>
              <div style="font-size: 12px; font-weight: 700; color: #707070;">이 스토리를 좀 더 빨리 만나보고 싶으시면 <v-icon size="16px">$vuetify.icons.heartOutlined</v-icon>를 눌러주세요!</div>
            </v-layout>
            <v-layout align-end v-else>
              <div>
                <div v-if="product.amount !== finalPrice" class="caption">
                  <span style="color: #ec2f54; font-weight: 700;" class="mr-1">{{ product.discount }}% 할인</span>
                  <span style="color: #9b9b9b; text-decoration: line-through;" class="mr-1">{{ addComma(product.amount) }}원</span>
                  <span style="color: #9b9b9b;" v-show="product.installment > 1">{{ addComma(finalPrice) }}원</span>
                </div>
                <div>
                  <span style="color: #222222; font-size: 24px; font-weight: 700;">{{ product.installment > 1 ? '월 ' : '' }}{{ addComma(Math.floor(finalPrice / product.installment / 10000)) }}만원</span>
                  <span style="color: #222222; font-size: 14px; font-weight: 700; letter-spacing: -0.2px;" class="ml-1">{{ product.installment > 1 ? '부터' : '' }}</span>
                </div>
                <div v-if="product.installment > 1">
                  <span style="font-size: 12px; font-weight: 700; color: #9b9b9b;">최대 할인 적용 {{ product.installment }}개월 할부시</span>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on }">
                      <span class="d-inline-block installment-tooltip" v-on="on">?</span>
                    </template>
                    <v-card style="background-color: #4a4a4a; color: #9b9b9b; border-radius: 10px;" flat>
                      <v-card-text>
                        <div>무이자 할부 적용 금액: 5만원 이상</div>
                        <div>하나카드: 2~3개월  삼성카드: 2~6개월</div>
                        <div>현대카드: 2~6개월  비씨카드: 2~6개월</div>
                        <div>국민카드: 2~5개월  씨티카드: 2~6개월</div>
                        <div class="text-xs-left">신한카드: 2~6개월  NH카드: 2~6개월</div>
                      </v-card-text>
                    </v-card>
                  </v-tooltip>
                </div>
              </div>
              <v-spacer></v-spacer>
              <div style="display: flex; flex: 0 0 auto; align-items: center;">
                <v-img style="display: inline-flex;flex-grow: 0;" :src="require('@/assets/img/icon-star-active.png')" width="24px" height="24px"></v-img>
                <span class="caption" style="color: #ec2f54;">{{ product.review_avg.toFixed(1) }}</span>
              </div>
            </v-layout>
            <v-divider class="mt-4"></v-divider>
          </v-card-text>

          <v-card-text class="summary-text pb-5" style="position: relative; background-color: #f8f8f8;">
            <!--            <div class="summary-more-gradient"></div>-->
            <div>
              <p class="mb-0" style="white-space: pre-wrap;">{{ product.summary }}</p>
            </div>
            <!--            <v-layout align-center style="width: 100%; height: 40px;">-->
            <!--              <v-btn flat small-->
            <!--                     color="#4a4a4a"-->
            <!--                     class="mr-0 my-0 px-1"-->
            <!--                     style="margin-left: -4px; min-width: 0;">-->
            <!--                더보기-->
            <!--                <v-icon size="16px">$vuetify.icons.arrowDown</v-icon>-->
            <!--              </v-btn>-->
            <!--            </v-layout>-->
          </v-card-text>

          <v-card-text style="padding: 0 20px; background-color: #f8f8f8;" v-if="product.amount">
            <v-layout row style="height: 96px;">
              <v-layout column mr-1 class="align-center justify-center" style="flex-basis: 50%; background-color: white; border-radius: 5px;">
                <div style="font-size: 24px; font-weight: 700; line-height: 32px; color: #ec2f54; letter-spacing: -0.6px;">{{ product.course_period }}</div>
                <div style="font-size: 14px; line-height: 24px; color: #707070; letter-spacing: -0.3px;">프로그램 기간</div>
              </v-layout>
              <v-layout column ml-1 class="align-center justify-center" style="flex-basis: 50%; background-color: white; border-radius: 5px;">
                <div style="font-size: 24px; font-weight: 700; line-height: 32px; color: #ec2f54; letter-spacing: -0.6px;">{{ product.course_target }}</div>
                <div style="font-size: 14px; line-height: 24px; color: #707070; letter-spacing: -0.3px;">프로그램 대상</div>
              </v-layout>
            </v-layout>
            <v-layout column
                      align-center
                      justify-center
                      v-html="product.summary_introduction"
                      style="padding: 24px 0 40px; color: #4a4a4a; font-size: 14px; line-height: 20px; letter-spacing: -0.3px;">
            </v-layout>
          </v-card-text>

        </v-card>
      </v-flex>

      <v-flex xs12 v-show="!loading">
        <v-tabs v-model="activeTab" slider-color="#4a4a4a" mandatory color="#f8f8f8">
          <v-layout row>
            <v-flex xs4>
              <v-tab :ripple="false" href="#Introduce" class="tab" @click="$vuetify.goTo('#Introduce', tabScrollOptions)">혜택</v-tab>
            </v-flex>
            <v-flex xs4>
              <v-tab :ripple="false" href="#Program" class="tab" @click="$vuetify.goTo('#Program', tabScrollOptions)">프로그램</v-tab>
            </v-flex>
            <v-flex xs4>
              <v-tab :ripple="false" href="#School" class="tab" @click="$vuetify.goTo('#School', tabScrollOptions)">학교 보기</v-tab>
            </v-flex>
          </v-layout>
        </v-tabs>
      </v-flex>

      <v-flex xs12 class="pa-0 ma-0" v-show="!loading">
        <v-card tile flat class="card-shadow">
          <!-- 혜택 -->
          <v-container class="pa-0" id="Introduce">
            <v-layout column>
              <div class="product-style body-1" v-html="product.package_contents"></div>
            </v-layout>
          </v-container>

          <!-- 프로그램, 학교 보기 -->
          <v-container class="pa-0">
            <v-layout column>
              <div class="product-style body-1" v-html="product.contents"></div>
              <!-- id="Program", id="School" 둘 다 걍 작성시에 넣을 것 -->

              <!--              <div class="mt-5">-->
              <!--                <ChannelListTile :idx="product.channels.idx"-->
              <!--                                 :title="product.channels.title"-->
              <!--                                 :introduce="product.channels.introduce"-->
              <!--                                 :subscribeCnt="product.channels.subscribe_cnt"-->
              <!--                                 :thumbnail="product.channels.thumbnail"-->
              <!--                                 :subscribes="product.channels.subscribes"-->
              <!--                                 @subscribe="subscribe(product.channels.idx)" />-->
              <!--              </div>-->
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 v-show="!loading">
        <v-card tile flat class="mt-2">
          <v-card-title><h2>연관 프로그램</h2></v-card-title>
          <v-card-text class="ma-0 pt-3 px-0 pb-4">
            <div class="store-swiper-container swiper-container"
                 style="padding: 0 16px 32px;">
              <div class="store-swiper-wrapper swiper-wrapper">
                <div class="store-swiper-slide swiper-slide"
                     v-for="(recommend, index) of product.recommends" :key="index">
                  <ProductCard :idx="recommend.idx"
                               :title="recommend.title"
                               :subtitle="recommend.subtitle"
                               :publishedAt="recommend.published_at"
                               :status="recommend.status"
                               :thumbnail="recommend.thumbnail"
                               :bookmarks="recommend.bookmarks"
                               :subtitle_color="recommend.subtitle_color"
                               @bookmark="bookmarkProduct(recommend.idx)" />
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-footer height="auto" color="#4a4a4a" dark class="footer-style">
          <v-container class="text-xs-left">
            <h1 class="pb-3">유스</h1>
            <v-layout justify-space-between align-center class="pt-3">
              <div style="font-size: 18px; font-weight: 700; letter-spacing: -0.5px; color: white;">크리에이터</div>
              <div>
                <v-btn small outline round class="ma-0 mr-2" color="#9b9b9b"
                       style="min-width: 70px; font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
                       target="_blank" href="https://www.youthcreator.me/">지원하기</v-btn>
                <v-btn small outline round class="ma-0" color="#9b9b9b"
                       style="min-width: 70px; font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
                       target="_blank" href="https://www.youthcreator.me/about-1">도움말</v-btn>
              </div>
            </v-layout>
            <v-layout justify-space-between align-center class="py-3">
              <div style="font-size: 18px; font-weight: 700; letter-spacing: -0.5px; color: white;">고객센터</div>
              <div>
                <v-btn small outline round class="ma-0" color="#9b9b9b"
                       style="min-width: 70px; font-size: 14px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
                       @click="inquiry">문의하기</v-btn>
              </div>
            </v-layout>
            <v-layout class="mb-2 pt-4" style="font-size: 12px; font-weight: 700; letter-spacing: -0.3px; color: #9b9b9b;">
              <span @click="$router.push({ name: 'TermsOfService' })">이용약관</span>ㅣ
              <span @click="$router.push({ name: 'PrivacyPolicy' })">개인정보처리방침</span>
            </v-layout>
            <v-layout class="text-xs-justify">
              <span style="font-size: 10px; color: #9b9b9b;">사업자 정보: {{ remarkText }}</span>
            </v-layout>
          </v-container>
        </v-footer>
      </v-flex>

      <v-footer fixed app
                v-show="!loading"
                :height="isNaN(eventCounter) ? '74px' : '124px'"
                class="px-3"
                style="background-color: white; border-top-right-radius: 30px; border-top-left-radius: 30px;">
        <v-layout column>
          <!-- 위쪽 카운터 -->
          <v-layout v-if="!isNaN(eventCounter)" row align-center style="height: 50px; padding-top: 14px;">
            <v-flex class="text-xs-left">
              <div class="highlighter">
                <span style="position: relative; z-index: 2;">최대혜택 <strong>이벤트 마감</strong>까지</span>
              </div>
              <div style="font-size: 10px; color: #9b9b9b;">본 이벤트는 <strong>선착순 마감 시 종료</strong>됩니다.</div>
            </v-flex>
            <v-flex class="event-counter">
              <template v-for="(item, key) in eventCounterString">
                <div :key="key" style="width: 29px;">
                  <div style="text-transform: capitalize; color: #4a4a4a; font-size: 10px; font-weight: 700;">{{ key }}</div>
                  <div style="font-size: 24px; font-weight: 700; color: #9013fe; line-height: 24px;">{{ item }}</div>
                </div>
                <div v-if="key === 'day'" :key="`${key}-colon`" style="width: 11px;"></div>
                <div v-else-if="key === 'hour' || key === 'min'" :key="`${key}-colon`"
                     style="width: 11px;">
                  <div style="font-size: 24px; font-weight: 700; color: #9013fe;">:</div>
                </div>
              </template>
            </v-flex>
          </v-layout>
          <!-- 아래 -->
          <v-layout row align-center style="height: 74px;">
            <v-btn icon small class="my-0 ml-1 mr-3" @click="bookmarkProduct(product.idx)">
              <v-icon :color="product.bookmarks ? 'primary' : ''">{{ product.bookmarks ? '$vuetify.icons.heartFilled' : '$vuetify.icons.heartOutlined' }}</v-icon>
            </v-btn>
            <v-divider vertical style="min-height: 16px; height: 16px; margin: auto;"></v-divider>

            <template v-if="product.status === 'ready'">
              <v-btn block large :outline="!product.alarms" :dark="product.alarms" color="primary" style="box-shadow: none;"
                     class="purchase-button my-0 ml-3 mr-0" @click="alarm">제작 알림 신청{{ product.alarms ? '중' : '' }}</v-btn>
            </template>

            <!--          <template v-else-if="product.purchases">-->
            <!--            <v-btn block large :outline="!product.purchases" :dark="product.purchases" color="primary" style="box-shadow: none;"-->
            <!--                   class="purchase-button my-0 ml-3 mr-0">no action...</v-btn>-->
            <!--          </template>-->

            <template v-else>
              <v-btn block large outline color="primary" class="purchase-button my-0 ml-3 mr-0" @click="dialog = true">무료 상담 신청</v-btn>
            </template>

          </v-layout>
        </v-layout>
      </v-footer>

      <!-- 상담 신청 다이얼로그 -->
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar flat fixed>
            <v-btn icon @click="dialog = false">
              <v-icon>$vuetify.icons.cancel</v-icon>
            </v-btn>
            <h3 class="display-2" style="margin-bottom: 2px">상담 신청</h3>
          </v-toolbar>

          <v-form v-model="visitMeta.valid">
            <v-layout row wrap pa-5 mt-5 class="text-xs-left visit-form">
              <v-flex xs12 mb-5 class="text-xs-center">
                <h2>상담을 위해 필요한<br>정보를 입력해주세요.</h2>
              </v-flex>

              <v-flex xs12 mb-4>
                <h3>* 상담 진행 방식을 선택해주세요.</h3>
                <v-radio-group row v-model="visitInfo.isCall" hide-details class="mt-2">
                  <v-radio on-icon="$vuetify.icons.confirm"
                           off-icon="$vuetify.icons.confirm"
                           color="primary"
                           value="visit">
                    <template v-slot:label>
                      <span :class="{ 'primary--text': visitInfo.isCall === 'visit' }">방문상담</span>
                    </template>
                  </v-radio>
                  <v-radio on-icon="$vuetify.icons.confirm"
                           off-icon="$vuetify.icons.confirm"
                           color="primary"
                           value="phone">
                    <template v-slot:label>
                      <span :class="{ 'primary--text': visitInfo.isCall === 'phone' }">전화상담</span>
                    </template>
                  </v-radio>
                  <v-radio on-icon="$vuetify.icons.confirm"
                           off-icon="$vuetify.icons.confirm"
                           color="primary"
                           value="kakaotalk">
                    <template v-slot:label>
                      <span :class="{ 'primary--text': visitInfo.isCall === 'kakaotalk' }">카톡상담</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-flex>

              <v-flex xs12>
                <h3 class="mb-3">* 필수 정보를 입력해주세요.</h3>
                <v-text-field label="이름"
                              placeholder="이름"
                              v-model="visitInfo.name"
                              :rules="[rules.required]"
                              required>
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="휴대폰 번호"
                              placeholder="000-0000-0000"
                              :rules="[rules.required]"
                              :mask="phoneMask"
                              v-model="visitInfo.phone"
                              required></v-text-field>
              </v-flex>
              <v-flex xs12 mb-4>
                <v-text-field label="생년월일(6자리)"
                              placeholder="예시: 010523"
                              :rules="[rules.required]"
                              mask="######"
                              v-model="visitInfo.birthday"></v-text-field>
              </v-flex>

              <v-flex xs12 mb-4>
                <h3>* 관심있는 국가를 선택해주세요.</h3>
                <span class="caption-form">중복선택 가능</span>
                <v-select append-icon="$vuetify.icons.arrowDown"
                          ref="nationSelect"
                          @click:append.stop="toggleSelectMenu($refs.nationSelect)"
                          :menu-props="{ 'offsetY': true, 'openOnClick': true, 'closeOnClick': false }"
                          placeholder="관심 국가"
                          v-model="visitInfo.interestNation"
                          required
                          :rules="[rules.requiredMultiple]"
                          multiple
                          :items="visitMeta.nations">
                  <template v-slot:item="{ item }">
                    {{ item }}
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 mb-4>
                <h3>* 희망하는 유학 기간을 선택해주세요.</h3>
                <v-select append-icon="$vuetify.icons.arrowDown"
                          ref="periodSelect"
                          @click:append.stop="toggleSelectMenu($refs.periodSelect)"
                          :menu-props="{ 'offsetY': true, 'openOnClick': true, 'closeOnClick': false }"
                          placeholder="희망 기간"
                          required
                          v-model="visitInfo.studyPeriod"
                          :rules="[rules.requiredMultiple]"
                          :items="visitMeta.durations">
                  <template v-slot:item="{ item }">
                    {{ item }}
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 mb-4>
                <h3>* 희망하는 유학 시작 시기를 선택해주세요.</h3>
                <v-date-picker no-title
                               type="month"
                               v-model="visitInfo.studyStartDate"
                               class="flat-calendar"
                               full-width
                               next-icon="$vuetify.icons.arrowRight"
                               prev-icon="$vuetify.icons.arrowLeft"
                               locale="ko"
                               color="#ec514f"
                               :min="minDate"></v-date-picker>
              </v-flex>

              <v-flex xs12 mb-4>
                <h3>* 상담 날짜 및 시간을 선택해주세요.</h3>
                <span class="mb-2 caption-form">월~금 11시~19시 (공휴일 제외)</span>
                <v-date-picker no-title
                               class="flat-calendar"
                               v-model="visitInfo.date"
                               full-width
                               next-icon="$vuetify.icons.arrowRight"
                               prev-icon="$vuetify.icons.arrowLeft"
                               locale="ko"
                               color="#ec514f"
                               :min="minDate"
                               :max="maxDate"
                               :allowed-dates="date => allowedDates(date)"
                               :day-format="date => date.split('-')[2]">
                </v-date-picker>
                <div class="caption" style="color: #ff5252" v-if="!visitInfo.date">필수사항입니다.</div>
                <v-select append-icon="$vuetify.icons.arrowDown"
                          label="상담 시간"
                          ref="timeSelect"
                          @click:append.stop="toggleSelectMenu($refs.timeSelect)"
                          :menu-props="{ 'offsetY': true, 'offsetOverflow': true, 'openOnClick': true, 'closeOnClick': false }"
                          required
                          class="mt-3"
                          v-model="visitInfo.time"
                          :rules="[rules.required]"
                          :items="visitMeta.times"
                          item-disabled="subheader">
                  <template v-slot:item="{ item }" :disabled="item.subheader">
                    <v-subheader v-if="item.subheader">{{ item.text }}</v-subheader>
                    <div v-else>{{ item.text }}</div>
                  </template>
                </v-select>
              </v-flex>

              <v-flex xs12 mb-4>
                <h3>궁금하신 점이 있으면 작성해주세요 :)</h3>
                <v-textarea placeholder="문의사항" v-model="visitInfo.question" no-resize counter="500"
                            :rules="[v => v.length <= 200 || '500자를 초과하는 부분은 제외됩니다.']"
                ></v-textarea>
              </v-flex>

              <v-flex xs12 v-show="visitInfo.isCall === 'visit'">
                <h3>방문상담 위치를 확인해주세요.</h3>
                <!--                <span class="mb-2 caption-form">{{ visitInfo.location }}</span>-->
                <!--                <v-select disabled label="상담 장소" :items="[ '서울 역삼점' ]"></v-select>-->
                <v-text-field readonly label="상담 장소" v-model="visitInfo.location"></v-text-field>
              </v-flex>

              <v-flex xs12 mb-4 v-show="visitInfo.isCall === 'visit'">
                <div id="map" style="height: 300px;"></div>
              </v-flex>

              <v-flex xs12 mb-2>
                <h3>어떻게 유스를 알게 되었나요?</h3>
                <span class="mb-2 caption-form">선택사항</span>
                <v-radio-group row v-model="visitInfo.funnel" hide-details class="mt-2">
                  <template v-for="(item, index) of visitMeta.funnels">
                    <v-radio :key="index"
                             :value="item.value"
                             on-icon="$vuetify.icons.confirm"
                             off-icon="$vuetify.icons.confirm"
                             color="primary"
                             class="mr-5 mb-2">
                      <template v-slot:label>
                        <span :class="{ 'primary--text': visitInfo.funnel === item.value }">{{ item.label }}</span>
                      </template>
                    </v-radio>
                  </template>
                </v-radio-group>
                <v-text-field v-if="visitInfo.funnel === 'other'"
                              label="기타"
                              placeholder="유튜브, 지인소개, ..."
                              v-model="visitInfo.funnelOther">
                </v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-expansion-panel class="expansion-panel-form">
                  <v-expansion-panel-content>
                    <template v-slot:actions>
                      <v-icon>$vuetify.icons.arrowDown</v-icon>
                    </template>
                    <template v-slot:header>
                        <v-checkbox on-icon="$vuetify.icons.confirm"
                                    off-icon="$vuetify.icons.confirm"
                                    color="primary"
                                    class="pt-0"
                                    style="margin-top: 10px;"
                                    required
                                    :rules="[rules.required]"
                                    :ripple="false"
                                    @click.stop
                                    v-model="visitInfo.agreePrivacy">
                          <template v-slot:label>
                            <div style="font-size: 16px;">
                              <span>{{ privacyTerm.title }} 동의</span>
                              <span class="caption-form">&nbsp;[필수]</span>
                            </div>
                          </template>
                        </v-checkbox>
                    </template>
                    <div v-html="privacyTerm.content" class="pa-3" style="height: 400px; overflow-y: scroll; border: 1px solid #f4f4f4; border-radius: 10px;"></div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
              <v-flex xs12>
                <v-btn color="#ec514f" class="mt-5" style="height: 56px; color: white;"
                       depressed :disabled="!visitMeta.valid || !visitInfo.date" block @click="submit">신청하기</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  // import videojs from 'video.js';
  import 'video.js/dist/video-js.css';
  import VideoPlayer from '@/components/VideoPlayer';
  import ProductCard from '@/components/ProductCard';
  // import ChannelListTile from '@/components/ChannelListTile';
  // import CommentListTile from '@/components/CommentListTile';
  // import ReviewListTile from "@/components/ReviewListTile";

  import terms from '@/assets/js/terms';

  import { intToCommaString, copyLink } from "@/util/util";
  import { mapGetters, mapActions, mapMutations } from 'vuex';

  export default {
    name: 'Visit',
    props: {
      idx: { type: Number, required: true },
      loading: { type: Boolean, required: true }
    },
    components: { VideoPlayer, ProductCard },
    computed: {
      ...mapGetters('product', [ 'product' ]),
      ...mapGetters('user', { userIdx: 'idx' }),
      minDate () {
        const offset = new Date().getTimezoneOffset();
        return new Date(new Date().getTime() - (offset * 60000)).toISOString().split('T')[0];
      },
      maxDate () {
        const offset = new Date().getTimezoneOffset();
        return new Date(new Date().getTime() - (offset * 60000) + (1000 * 60 * 60 * 24 * 31)).toISOString().split('T')[0];
      },
      productTitle () {
        return this.loading ? '' : this.product.title;
      },
      playerOptions () {
        return {
          // language: 'ko',
          // autoplay: false,
          // muted: false,
          // playbackRates: [0.5, 1.0, 1.5, 2.0],
          sources: [{ src: `${this.$storage}/video/preview/${this.product.preview}`, type: 'video/mp4'}],
          poster: this.thumbnailSrc,
          hls: {
            overrideNative: true
          },
          html5: {
            nativeAudioTracks: false,
            nativeTextTracks: false
          },
        };
      },
      origin () {
        return window.location.origin;
      },
      thumbnailSrc () {
        return this.product.thumbnail && this.isImageLoaded ? `${this.$storage}/store/${this.product.thumbnail}` : require('@/assets/img/thumbnail-default.png');
      },
      finalPrice () {
        return this.product.discount > 0 ? Math.floor(this.product.amount * (100 - this.product.discount) / 100) : this.product.amount;
      },
      privacyTerm () {
        return terms.visitPrivacy;
      },
      phoneMask () {
        return this.visitInfo.phone.value && this.visitInfo.phone.value.length <= 10 ? '###-###-#####' : '###-####-####';
      },
      eventCounterString () {
        if (isNaN(this.eventCounter)) {
          return {};
        }
        const day = Math.floor(this.eventCounter / (1000 * 60 * 60 * 24));
        const hour = Math.floor((this.eventCounter % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const min = Math.floor((this.eventCounter % (1000 * 60 * 60)) / (1000 * 60));
        const sec = Math.floor((this.eventCounter % (1000 * 60)) / 1000);
        return {
          day: day < 0 ? `00` : day < 10 ? `0${day}` : day,
          hour: hour < 0 ? `00` : hour < 10 ? `0${hour}` : hour,
          min : min < 0 ? `00` : min < 10 ? `0${min}` : min,
          sec : sec < 0 ? `00` : sec < 10 ? `0${sec}` : sec
        };
      }
    },
    data () {
      return {
        isOpenNationMenu: false,
        player: null,
        tooltip: false,
        dialog: false,
        visitMeta: {
          valid: false,
          nations: [ '미국', '캐나다', '영국', '호주', '뉴질랜드', '아일랜드', '몰타' ],
          times: [
            { text: '오전', subheader: true },
            { text: '오전 11시 ~ 낮 12시', value: '11:00' },
            { text: '오후', subheader: true },
            { text: '낮 12시 ~ 1시', value: '12:00' },
            { text: '오후 1시 ~ 2시', value: '13:00' },
            { text: '오후 2시 ~ 3시', value: '14:00' },
            { text: '오후 3시 ~ 4시', value: '15:00' },
            { text: '오후 4시 ~ 5시', value: '16:00' },
            { text: '오후 5시 ~ 6시', value: '17:00' },
            { text: '오후 6시 ~ 7시', value: '18:00' },
            { text: '오후 7시 ~ 8시', value: '19:00' },
          ],
          durations: [ '4주 이내', '3개월 이내', '6개월 이내', '1년 미만', '1년 이상'],
          funnels: [
            { label: '네이버', value: 'naver' },
            { label: '페이스북', value: 'facebook' },
            { label: '인스타그램', value: 'instagram' },
            { label: '기타', value: 'other' },
          ]
        },
        rules: {
          required: v => !!v || '필수사항입니다.',
          requiredMultiple: v => !!v.length || '필수사항입니다.'
        },
        visitInfo: {
          isCall: 'visit',
          name: '',
          phone: '',
          birthday: '',
          interestNation: [],
          studyPeriod: '',
          studyStartDate: '',
          question: '',
          date: '',
          time: '',
          location: '서울 역삼점 (서울시 강남구 역삼로 180, 마루180)',
          agreePrivacy: true,
          funnel: '',
          funnelOther: '',
        },
        // loading: true,
        time: parseInt(new Date().getTime() / 1000),
        isImageLoaded: true,
        isScroll: false,
        activeTab: null,
        tabScrollOptions: {
          duration: 300,
          offset: 100,
          easing: 'easeInOutQuad',
        },
        swiper: null,
        talkPage: {
          current: 2,
          max: 2
        },
        talk: '',
        commentTo: -1,
        reviewPage: {
          current: 2,
          max: 2
        },
        eventCounter: 0,
        remarkText: '(주)GLORANGㅣ대표 황태일ㅣ개인정보보호 책임자 황태일ㅣ서울특별시 강남구 역삼로 180 마루 180 1층ㅣ전화 02-6929-4070ㅣ사업자등록번호 596-81-00999ㅣ통신판매업신고: 2019-서울강남-01817ㅣ(주)글로랑은 통신판매중개자이며 통신판매의 당사자가 아닙니다. 따라서 (주)글로랑은 상품, 거래 정보 및 거래에 대하여 책임을 지지 않습니다.',
      };
    },
    created () {
      if (this.product.time_deadline) {
        this.eventCounter = new Date(this.product.time_deadline).getTime() - new Date().getTime() + (new Date().getTimezoneOffset() * 60000);
        if (!isNaN(this.eventCounter) && this.eventCounter > 0) {
          setInterval(() => {
            this.eventCounter -= 1000;
          }, 1000);
        } else {
          this.eventCounter = NaN;
        }
      } else {
        this.eventCounter = NaN;
      }
    },
    mounted () {
      this.swiperInit();
      window.addEventListener('scroll', this.changeSectionByScroll);
    },
    updated () {
      if (this.swiper) this.swiper.update();
      else this.swiperInit();
    },
    beforeDestroy () {
      if (this.swiper) this.swiper.destroy();
    },
    destroyed () {
      window.removeEventListener('scroll', this.changeSectionByScroll);
    },
    watch: {
      talk (text) {
        if (text === '') this.commentTo = -1;
      },
      dialog (v) {
        if (v) {
          this.$nextTick(() => {
            /* eslint-disable */
            let mapContainer = document.getElementById('map'); // 지도를 표시할 div
            let mapOption = {
              center: new kakao.maps.LatLng(37.496522, 127.038803), // 지도의 중심좌표
              level: 5, // 지도의 확대 레벨
            };
            // 지도를 생성한다
            let kakaoMap = new kakao.maps.Map(mapContainer, mapOption);
            // 지도에 마커를 생성하고 표시한다
            let marker = new kakao.maps.Marker({
              position: new kakao.maps.LatLng(37.495522, 127.038803), // 마커의 좌표
              map: kakaoMap // 마커를 표시할 지도 객체
            });
            // 마커에 최대 너비 제한 있는지 자꾸 두줄 됨
            // 커스텀 오버레이를 생성하고 지도에 표시한다
            let customOverlay = new kakao.maps.CustomOverlay({
              map: kakaoMap,
              content: '<div style="padding:0 5px;background:#fff;border:1px solid #4a4a4a;">서울시 강남구 역삼로 180 (마루180)</div>',
              position: new kakao.maps.LatLng(37.495522, 127.038803), // 커스텀 오버레이를 표시할 좌표
              xAnchor: 0.5, // 컨텐츠의 x 위치
              yAnchor: 3 // 컨텐츠의 y 위치
            });
            /* eslint-enable */
          });
        }
      }
    },
    methods: {
      ...mapMutations('product', {
        mutateToggleSubscription: 'TOGGLE_SUBSCRIPTION',
        mutateToggleBookmark: 'TOGGLE_BOOKMARK',
        mutateToggleAlarm: 'TOGGLE_ALARM'
      }),
      ...mapActions('product', [
        'selectProduct', 'toggleBookmark', 'createTalk', 'createComment', 'toggleLikeTalk', 'toggleLikeComment',
        'reportTalk', 'reportComment', 'deleteTalk', 'deleteComment', 'selectComments', 'toggleAlarm',
        'purchaseFreeProduct', 'createConsultingForm'
      ]),
      ...mapActions('channel', [ 'toggleSubscription' ]),
      ...mapMutations('home', { mutationToggleStoreBookmark: 'TOGGLE_STORE_BOOKMARK' }),
      goBack () {
        // if (window.history.length < 2) {
        //   this.$router.push({ name: 'Home' });
        // } else {
        //   this.$router.go(-1);
        // }
        this.$router.go(-1);
      },
      swiperInit () {
        let container = document.querySelector('.store-swiper-container');
        if (container) {
          this.swiper = new Swiper('.store-swiper-container', {
            direction: 'horizontal',
            slidesPerView: 2,
            spaceBetween: 10,
          });
        }
      },
      onScroll () {
        this.isScroll = window.scrollY > this.$refs.introHeader.$el.offsetHeight + 56;
      },
      changeSectionByScroll () {
        if (!document.getElementById('Program')) return;
        // 스크롤 -> 탭 전환
        const program = document.getElementById('Program').offsetTop;
        const school = document.getElementById('School').offsetTop;
        if (window.scrollY < program - 50) {
          this.activeTab = 'Introduce';
        } else if (window.scrollY >= program - 50 && window.scrollY < school - 50) {
          this.activeTab = 'Program';
        } else {
          this.activeTab = 'School';
        }
      },
      // subscribe (idx) {
      //   if (this.userIdx === 0) {
      //     this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
      //   } else {
      //     this.toggleSubscription(idx).then(response => {
      //       this.mutateToggleSubscription({ idx, flag: response.data });
      //     }).catch(err => {
      //       console.error(err);
      //     });
      //   }
      // },
      bookmarkProduct (idx) {
        if (this.userIdx === 0) {
          this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        } else {
          this.toggleBookmark(idx).then(response => {
            this.mutateToggleBookmark({idx, flag: response.data});
            this.mutationToggleStoreBookmark({idx, flag: response.data});
          }).catch(err => {
            console.error(err);
          });
        }
      },
      submit () {
        this.createConsultingForm({
          storeIdx: this.idx,
          type: this.visitInfo.isCall,
          location: this.visitInfo.isCall === 'visit' ? '서울 역삼점' : this.visitInfo.isCall === 'phone' ? '전화' : '카톡',
          name: this.visitInfo.name,
          phone: this.visitInfo.phone,
          birthday: this.visitInfo.birthday,
          channel: this.visitInfo.funnel === 'other' ? this.visitInfo.funnelOther : this.visitInfo.funnel,
          interestNation: this.visitInfo.interestNation.join(','),
          studyPeriod: this.visitInfo.studyPeriod,
          studyStartDate: this.visitInfo.studyStartDate,
          question: this.visitInfo.question,
          schedule: (new Date(`${this.visitInfo.date}T${this.visitInfo.time}:00+09:00`)).getTime(),
        }).then(response => {
          console.log(response);
          if (this.visitInfo.isCall === 'kakaotalk') {
            if (confirm('상담이 신청되었습니다 👏 카카오톡 채팅으로 바로 연결할까요?')) {
              // eslint-disable-next-line
              Kakao.PlusFriend.chat({
                plusFriendId: '_ygxjIT'
              });
            }
          } else {
            this.$router.push({ name: 'ConsultingFormComplete' });
          }
          this.dialog = false;
        }).catch(err => {
          console.error(err);
        });
      },
      alarm () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else {
          this.toggleAlarm(this.idx).then(response => {
            this.mutateToggleAlarm(response.data);
          }).catch(err => {
            console.error(err);
          });
        }
      },
      inquiry () {
        if (this.userIdx === 0) this.$router.replace({ name: 'SocialLogin', query: { redirect: this.$route.path }});
        else {
          // eslint-disable-next-line
          Kakao.PlusFriend.chat({
            plusFriendId: '_ygxjIT'
          });
        }
      },
      addComma (int) {
        return intToCommaString(int);
      },
      share () {
        copyLink(window.location.href);
        // this.showSnackbar('링크가 복사되었습니다.');
        alert('링크가 복사되었습니다.');
      },
      onPlayerReady (player) {
        this.player = player;
      },
      onLoaded (player) {
        console.log('onLoaded', player);
        player.play();
      },
      onEnded (player) {
        console.log('onEnded', player);
      },
      onError (player) {
        console.log('onError: ', player);
      },
      toggleSelectMenu (refs) {
        // console.log(refs);
        if (refs.isMenuActive) {
          refs.blur();
        } else {
          refs.focus();
          refs.activateMenu();
        }
      },
      allowedDates (date) {
        if (this.product.time_invalids.includes(date)) {
          return false;
        }
        return new Date(date).getDay() % 6 !== 0;
        // switch (date) {
        //   case '2019-12-25':
        //     return false;
        //   default:
        //     return new Date(date).getDay() % 6 !== 0;
        // }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .channel-small-icon {
    flex-shrink: 0;

    width: 33px;
    /*height: 19px;*/
    line-height: 19px;
    border-radius: 8px;
    background-color: map_get($colors, charcoal);

    color: white;
    font-size: 10px;
  }

  .custom-chip {
    padding: 0 6px;
    line-height: 22px;
    background-color: map_get($colors, charcoal);
    border-radius: 5px;

    color: white;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: -0.2px;
  }

  .summary-text {
    padding-right: 20px;
    padding-left: 20px;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.3px;
    color: map_get($colors, charcoal);
  }

  /deep/.extension-padding .v-toolbar__extension {
    padding: 0;
  }

  .top-button {
    width: 24px;
    height: 24px;
    flex: 0 0 auto;
    &.v-btn--depressed {
      border-color: #cdcdcd !important;
    }
  }

  .top-right-radius {
    width: auto;
    border-top-right-radius: 40px;
    // box-shadow: 0 -8px 10px 0 rgba(black, 0.06);
  }

  .summary-more-gradient {
    position: absolute;
    top: 16px;
    left: 0;
    width: 100%;
    height: 120px;
    background-image: linear-gradient(to bottom, rgba(#f8f8f8, 0) 50%, rgba(#f8f8f8, 1) 100%);
  }

  .installment-tooltip {
    margin-left: 8px;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    font-weight: 700;
    color: white;
    border-radius: 50%;
    background-image: linear-gradient(to bottom, #818181, #4a4a4a);
  }

  .package {
    &-text {
      font-size: 14px;
      letter-spacing: -0.2px;
      color: map_get($colors, charcoal);
      line-height: 24px;
    }
    &-text-big {
      font-weight: 300;
      font-size: 24px;
      letter-spacing: -0.3px;
      color: map_get($colors, charcoal);
      line-height: 30px;
    }
  }

  .purchase-button {
    border-radius: 24px;
    background-color: white;
    margin-left: 16px;
    margin-right: 16px;

    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.3px;
  }

  /deep/ .v-tabs__container {
    align-items: center;
    justify-content: space-between;
    height: 40px;
  }

  /deep/.tab {
    & > a {
      padding-left: 0;
      padding-right: 0;
      color: map_get($colors, brown-crey);
      font-size: 16px;
      letter-spacing: -0.3px;
      &.v-tabs__item--active {
        color: map_get($colors, charcoal);
      }
    }
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map_get($colors, background-shadow);
  }

  .footer-style {
    color: white;
  }

  .display-4 {
    word-break: keep-all;
    word-wrap: break-word;
  }

  /deep/.expansion-panel-style {
    box-shadow: none;
    .v-expansion-panel__header {
      /*height: 100%;*/
      justify-content: center;
      background-image: linear-gradient(to bottom, white, #f8f8f8);
    }
    .v-expansion-panel__container--active {
      .v-expansion-panel__header {
        background-image: none;
      }
    }
    .v-expansion-panel__header__icon {
      width: 16px;
      height: 16px;
      i {
        vertical-align: baseline;
      }
      i:before {
        font-size: 16px;
      }
    }
  }

  .chapter-text {
    font-size: 16px;
    font-weight: 700;
    color: map_get($colors, primary) !important;
    letter-spacing: -0.3px;
    padding-bottom: 8px;

    word-break: keep-all;
    white-space: pre-wrap;
  }

  /deep/.list-padding .v-list__tile {
    padding-right: 6px;
    height: auto;
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

  /deep/ .package-more-holder {
    text-align: left;
    width: 100%;
    max-width: 360px;
    margin: auto;
    align-items: center;
    & > .text-wrapper {
      min-width: 280px;
    }
  }

  .lecture-title {
    white-space: pre-wrap;
    padding-left: 20px;
    &:before {
      content: '\2022';
      position: absolute;
      left: 20px;
    }
  }

  .more-button-style {
    font-size: 14px;
    font-weight: 700;
    letter-spacing: -0.2px;
    color: #4a4a4a !important;
    text-transform: unset;
    height: 38px;
    border: 1px solid #cdcdcd !important;
    border-radius: 19px;
    background-color: #f8f8f8 !important;
  }

  ::v-deep.v-tooltip__content {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }


  .caption-form {
    font-size: 12px;
    line-height: 12px;
    color: #9b9b9b;
    letter-spacing: -0.3px;
  }
  ::v-deep.visit-form {
    .v-input__slot::before {
      border-color: #f4f4f4 !important;
    }
  }
  ::v-deep.flat-calendar {
    box-shadow: none;
    .v-date-picker-table {
      padding: 0;
      height: auto;
    }
  }
  ::v-deep.expansion-panel-form {
    box-shadow: none;
    .v-expansion-panel__header {
      padding: 12px 0;
    }
  }
  ::v-deep.v-input--checkbox {
    .v-input__slot {
      margin-bottom: 0 !important;
    }
    .v-messages {
      min-height: 12px;
    }
    i {
      margin: auto;
      font-size: 16px;
    }
    input[aria-checked=false] ~ i {
      color: #cdcdcd !important;
    }
  }

  .event-counter {
    flex: 0 0 auto;
    & > div {
      display: inline-block;
      height: 100%;
    }
  }
  .highlighter {
    position: relative;
    width: fit-content;
    line-height: 16px;
    margin-bottom: 4px;
    font-size: 16px;
    letter-spacing: -0.77px;
    color: #ec2f54;
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      display: block;
      width: 100%;
      height: 6px;
      background-color: #fff689;
      z-index: 1;
    }
  }
</style>
